import { useCallback, useEffect, useState, Fragment } from "react";
import { Grid, Button, IconButton } from "@mui/material";
import { StyledLink } from "components/shared/Link";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { StyledStack, StyledTitle } from "./AddCategory.style";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import CategoryCard from "components/category";
import { getCategoryNewsRequest } from "api/requests";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { PAGINATION_LIMIT } from "constants";
import PaginationCM from "components/shared/Pagination";
import TableCM from "components/shared/Table";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import GenarateHeadCell from "helper/generate-head-cell";
import BackButton from "components/shared/BackButton";

const headCells = GenarateHeadCell("newscategory");

export default function Category() {
  const navigate = useNavigate();
  const [category, setCategory] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);

  const handelSearch = (e) => getCategory(e);

  const getCategory = useCallback(
    async (search) => {
      const res = await request({
        url: getCategoryNewsRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search,
        },
      });

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        edit: (
          <Link to={`/news/category/${items.id}`}>
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
        ),
      }));

      setCategory({ data: transformedData, count: res.count });
    },
    [page, request]
  );

  useEffect(() => {
    getCategory();
  }, [page, getCategory]);

  return (
    <DrawerCM title="زیردسته آموزش" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <Grid item mt={3} xs={12}>
            <BackButton Route={"/news"}/>
          </Grid>
          <Grid item xs={12} my={2}>
            <TableCM
              title="زیردسته آموزش"
              rows={category.data}
              headCells={headCells}
              page={page}
              addNewsCategory
            />
          </Grid>
          {category.data.length > 0 ? (
            <PaginationCM
              handleChange={(e, val) => setPage(val)}
              page={page}
              count={category.count}
            />
          ) : (
            " "
          )}
        </Grid>
      )}
    </DrawerCM>
  );
}
